import { Col, FormGroup, FormLabel, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import InputNumeric from "../../../components/Forms/Element/InputNumeric";
import ProductWithStockControlMultiSelect from "../../../components/Custom/Main/Product/ProductWithStockControlMultiSelect";
import { useBranch } from "../../../../context/BranchContext";
import BranchSelect from "../../../components/Custom/Main/Branch/BranchSelect";
import { useEffect, useState } from "react";
import TextArea from "../../../components/Forms/Element/TextArea";
import FormSection from "../../../components/Common/Form/FormSection";
import AsteriskRequired from "../../../components/Common/AsteriskRequired";
import StockMovementTypeCards from "../../../components/Custom/StockControl/Restock/StockMovementTypeCards";
import HintTooltip from "../../../components/Common/HintTooltip";
import HintCallout from "../../../components/Common/HintCallout";

const Form = (props) => {

    const { t } = useTranslation();
    const { formik, setType, type, resetForm } = props;
    const { selectedBranch } = useBranch();

    const inDescription = t('restock_in_description');

    // Desablita o campo quando for selecionado uma filial no contexto.
    // Se tiver marcado como todas, habilita e exibe todas as filiais para que o usuário escolha.
    const [disabledBranch, setDisabledBranch] = useState(false);

    useEffect(() => {
        if (selectedBranch === null) {
            setDisabledBranch(false);
            formik.setFieldValue('branch', null);
        } else {
            // Deixa marcado a filial que está no contexto.
            formik.setFieldValue('branch', {
                label: selectedBranch.name,
                value: selectedBranch.id
            });
            setDisabledBranch(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedBranch, resetForm]);

    useEffect(() => {
        formik.setFieldValue('description', inDescription);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetForm]);

    const handleMovementChange = (option) => {
        setType(option.value);
        formik.setFieldValue('description', option.description);
    };

    return (
        <>
            <div className="form-layout form-layout--spaced">
                <FormSection
                    title={t('basic_information')}
                    description={t('restock_basic_information_hint')}
                    icon="fa-solid fa-boxes-stacked"
                >
                    <Row className="g-3">
                        <Col md={6}>
                            <FormLabel>
                                {t('products')} <AsteriskRequired />
                                <HintTooltip text={t('restock_products_hint')} />
                            </FormLabel>
                            <ProductWithStockControlMultiSelect
                                name="products"
                                value={formik.values.products}
                                onChange={(value) =>
                                    formik.setFieldValue('products', value)
                                }
                                onBlur={formik.handleBlur}
                                error={formik.errors.products} />
                        </Col>
                        <Col md={3}>
                            <FormLabel>
                                {t('branch')} <AsteriskRequired />
                                <HintTooltip text={t(disabledBranch ? 'restock_branch_locked_hint' : 'restock_branch_hint')} />
                            </FormLabel>
                            <BranchSelect
                                name="branch"
                                value={formik.values.branch}
                                onChange={(value) =>
                                    formik.setFieldValue('branch', value)
                                }
                                onBlur={formik.handleBlur}
                                error={formik.errors.branch}
                                isDisabled={disabledBranch} />
                        </Col>
                        <Col md={3}>
                            <FormGroup>
                                {/* No ajuste, a quantidade é o saldo final, não uma entrada ou saída. */}
                                <FormLabel>
                                    {t('quantity')} <AsteriskRequired />
                                    <HintTooltip text={t(type === 'ADJUSTMENT' ? 'restock_qty_adjustment_hint' : type === 'OUT' ? 'restock_qty_out_hint' : 'restock_qty_in_hint')} />
                                </FormLabel>
                                <InputNumeric
                                    name="qty"
                                    value={formik.values.qty}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.qty} />
                            </FormGroup>
                        </Col>
                    </Row>
                </FormSection>

                <FormSection
                    title={t('movement_type')}
                    description={t('restock_movement_type_hint')}
                    icon="fa-solid fa-right-left"
                >
                    <StockMovementTypeCards value={type} onChange={handleMovementChange} />
                    <div className="mt-3">
                        <HintCallout>{t('restock_sale_replenishment_hint')}</HintCallout>
                    </div>
                </FormSection>

                <FormSection
                    title={t('description')}
                    description={t('restock_description_hint')}
                    icon="fa-solid fa-note-sticky"
                >
                    <Row>
                        <Col md={12}>
                            <TextArea
                                name="description"
                                style={{ height: "120px" }}
                                maxLength={80}
                                value={formik.values.description}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                counter="true"
                                placeholder={t('description_placeholder')}
                            />
                            <div className="mt-2">
                                <HintCallout icon="fa-info-circle">{t('restock_description_examples_hint')}</HintCallout>
                            </div>
                        </Col>
                    </Row>
                </FormSection>
            </div>
        </>
    );
}

export default Form;
